import { DEX_TYPE } from '@/config/constants';
import { feature, features as featureConstant } from '@/utils/feature-verifier';

const dexGuard = (meta) => meta.dispatch(dexGuardAction(meta));
const DEX_ENV = process.env.REACT_APP_DEX_ENV || DEX_TYPE.SGTRADEX;

const dexGuardAction = (meta) => (_dispatch, getState) => {

	const state = getState();
	const dex = feature(featureConstant.MULTIDEX) ? state.dexConfig.dexEnv : DEX_ENV;

	if (Array.isArray(meta?.allowedDex) && !meta.allowedDex.includes(dex)) {
        return '/';
    }

	return null
}

export { dexGuard }
